<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">전자 계약</span>
            <span class="txt">
                발송한 계약서 내역을 확인하고, 자주 쓰는 템플릿(서식)을 등록하거나 수정할 수 있습니다.
            </span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div class="com-tab">
                <span v-for="(item, index) in submenus" :key="index">
                    <router-link
                        v-show="item.valid"
                        :class="{ on: $route.name == item.name }"
                        :to="{ ...item, params: {} }"
                    >
                        {{ item.label }}
                    </router-link>
                </span>
            </div>

            <table class="com-table left" style="margin-top: 30px">
                <colgroup>
                    <col style="width: 60px" />
                    <col style="width: 500px" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>기간</th>
                        <td>
                            <div class="com-calendar-wrap">
                                <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                                <div class="com-dash"><span class="dash">~</span></div>
                                <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                                <select-form
                                    style="margin-left: 10px"
                                    :select-data="['오늘', '어제', '이번달', '지날달', '3개월', '6개월', '12개월']"
                                    :select-value="[
                                        'today',
                                        'yesterday',
                                        'thisMonth',
                                        'prevMonth',
                                        'threeMonth',
                                        'sixMonth',
                                        'year',
                                    ]"
                                    :selected-value="period"
                                    @update:set="(val) => periodc(val)"
                                ></select-form>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>검색어</th>
                        <td>
                            <div class="com-calendar-wrap">
                                <select-form
                                    style="margin-right: 10px"
                                    :select-data="['계약서명', '발송인명', '수신인명', '수신전화번호', '내용', '메모']"
                                    :select-value="[1, 2, 3, 4, 5, 6]"
                                    :selected-value="searchDivision"
                                    @update:set="(val) => setSearchDivision(val)"
                                ></select-form>
                                <input
                                    ref="refSearchKey"
                                    v-model="searchStr"
                                    placeholder=""
                                    type="text"
                                    style="width: 400px"
                                    @keyup="onKeydownSearchKey($event)"
                                    v-on:keyup.enter="onEventSearch"
                                />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>계약서 유형</th>
                        <td>
                            <div class="com-calendar-wrap">
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchMethod == '' ? 'active' : ''}`"
                                    @click="onSearchMethod('')"
                                >
                                    전체
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchMethod == 'P' ? 'active' : ''}`"
                                    @click="onSearchMethod('P')"
                                >
                                    직원
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchMethod == 'M' ? 'active' : ''}`"
                                    @click="onSearchMethod('M')"
                                >
                                    회원
                                </button>
                                <button
                                    class="com-btn border-button general-button"
                                    :class="`${searchMethod == 'E' ? 'active' : ''}`"
                                    @click="onSearchMethod('E')"
                                >
                                    기타
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="bottom-btn" style="margin-top: 20px">
                <button class="com-btn" @click="onSearch">검색</button>
                <button class="com-btn border-button general-button big" @click="onConditionInit">조건 초기화</button>
            </div>

            <div class="com-table-content">
                <div class="table-top-container">
                    <div class="left-box">
                        <p class="table-top-title"><strong>문서 내역</strong></p>
                    </div>
                    <div class="right-box">
                        <span class="table-top-count" style="margin-right: 10px">
                            총
                            <span class="blue">{{ contractSendListPagingInfo.totalItems }}</span>
                            개
                        </span>
                        <a class="com-btn red" style="margin-right: 10px" @click="deleteDocument">삭제</a>
                        <a class="com-btn blue" @click="registerDocument">등록</a>
                    </div>
                </div>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 100px" />
                        <col style="width: 245px" />
                        <col style="width: 100px" />
                        <col style="width: 145px" />
                        <col style="width: 285px" />
                        <col style="width: 155px" />
                        <col style="width: 155px" />
                        <col style="width: 170px" />
                        <col style="width: 170px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                                <div class="com-check">
                                    <input
                                        id="check-all"
                                        v-model="selectedAll"
                                        name="check-all"
                                        type="checkbox"
                                        @click="checkedAll"
                                    />
                                    <label for="check-all"></label>
                                </div>
                            </th>
                            <th>
                                <button
                                    :class="
                                        contractSendListSortColumn == 'e_cre_dt'
                                            ? contractSendListSortType == 'DESC'
                                                ? ''
                                                : 'degree'
                                            : ''
                                    "
                                    @click="onClickSendDt"
                                >
                                    등록일시
                                </button>
                            </th>
                            <th>구분</th>
                            <th>계약서명</th>
                            <th>발송인</th>
                            <th>수신인</th>
                            <th>수신전화번호</th>
                            <th>메모</th>
                            <th class="table-end-tooltip">
                                다운로드
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <p class="txt">등록된 파일 형식으로 다운로드됩니다.</p>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(t, i) in contractSendList" :key="i">
                            <td>
                                <div class="com-check">
                                    <input :id="t.e_id" v-model="selected" :value="i" name="check-1" type="checkbox" />
                                    <label :for="t.e_id"></label>
                                </div>
                            </td>
                            <td>
                                {{ t.e_cre_dt | timestampFilter2 }}
                            </td>
                            <td>
                                {{ t.e_contract_member_type | getContractMemberType }}
                            </td>
                            <td>
                                <div style="width: 20vw">
                                    <div
                                        class="line-blind"
                                        style="text-decoration: underline; cursor: pointer"
                                        @click="onShowDocument(i)"
                                    >
                                        {{ t.e_contract_name }}
                                    </div>
                                </div>
                            </td>
                            <td>
                                {{ t.cen_sender_name }}
                            </td>
                            <td>
                                {{ t.recipient_name }}
                            </td>
                            <td>
                                {{ t.recipient_phone | phoneNumberFilter }}
                            </td>
                            <td>
                                <div style="width: 10vw">
                                    <div class="line-blind">{{ t.e_memo }}</div>
                                </div>
                            </td>
                            <td>
                                <button class="com-btn" @click="onDownloadDocument(t.e_file_group_id)">다운로드</button>
                            </td>
                        </tr>
                        <tr v-if="contractSendList.length === 0">
                            <td colspan="100">등록된 내역이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
                <div class="com-btn-area table-bottom-func">
                    <div class="left-box">
                        <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
                    </div>
                    <div class="right-box">
                        <select-form
                            :select-data="[...sortTypeList]"
                            :select-value="[...sortTypeValueList]"
                            :selected-value="contractSendListPagingInfo.limit"
                            class="float-right"
                            @update:set="changeLimit"
                        ></select-form>
                    </div>
                </div>
                <b-pagination
                    v-model="contractSendListPagingInfo.page"
                    :per-page="contractSendListPagingInfo.limit"
                    :total-rows="contractSendListPagingInfo.totalItems"
                    align="center"
                    aria-controls="my-table"
                    first-class="first"
                    last-class="last"
                    next-class="next"
                    prev-class="prev"
                    @change="handlerPagenation($event, 'contractSendList')"
                ></b-pagination>
            </div>
        </template>
        <div v-show="addDocument" class="layer-pop square">
            <div class="view-content small-padding" style="width: auto">
                <button class="close" @click="closeDocumentPop">
                    <span class="blind">Popup Close</span>
                </button>
                <div class="com-scroll-y">
                    <p class="pop-tit" style="font-size: 18px; margin-bottom: 15px">
                        문서 {{ selectedDocumentIndex == -1 ? '등록' : '수정' }}
                    </p>
                    <table class="com-table left" style="margin-top: 20px">
                        <colgroup>
                            <col style="width: 200px" />
                            <col style="width: 400px" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>
                                    계약서 유형
                                    <span class="require">*</span>
                                </th>
                                <td style="padding: 10px">
                                    <div class="general-input-component" style="margin-top: 5px">
                                        <div class="com-radio">
                                            <input
                                                type="radio"
                                                name="radio_contract_type"
                                                id="contract_type_employee"
                                                value="P"
                                                v-model="contractType"
                                            />
                                            <label for="contract_type_employee" class="label-black">직원</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                type="radio"
                                                name="radio_contract_type"
                                                id="contract_type_member"
                                                value="M"
                                                v-model="contractType"
                                            />
                                            <label for="contract_type_member" class="label-black">회원</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                type="radio"
                                                name="radio_contract_type"
                                                id="contract_type_etc"
                                                value="E"
                                                v-model="contractType"
                                            />
                                            <label for="contract_type_etc" class="label-black">기타</label>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    계약서명
                                    <span class="require">*</span>
                                </th>
                                <td style="padding: 10px">
                                    <input
                                        v-model="contractName"
                                        style="width: 100%"
                                        type="text"
                                        @keyup="onKeyupContractName"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    발송인
                                    <span class="require">*</span>
                                </th>
                                <td style="padding: 10px">
                                    <select-form
                                        style="width: 100%"
                                        :disabled="chainCenterType.length == 1"
                                        :select-data="[...chainCenterType]"
                                        :select-value="[...chainCenterTypeValue]"
                                        :selected-value="sender"
                                        @update:set="(val) => setSender(val)"
                                    ></select-form>
                                </td>
                            </tr>
                            <tr v-show="contractType != 'E'">
                                <th>
                                    수신인
                                    <span class="require">*</span>
                                </th>
                                <td style="padding: 10px">
                                    <select-form
                                        v-if="contractType == 'P'"
                                        style="width: 100%"
                                        :select-data="['수신인 선택', ...centerStaffList]"
                                        :select-value="[null, ...centerStaffValueList]"
                                        :selected-value="recipient"
                                        @update:set="(val) => setRecipient(val)"
                                    ></select-form>
                                    <div v-else style="display: flex">
                                        <input
                                            v-model="recipientSearchStr"
                                            placeholder="회원명, 연락처('-' 제외)"
                                            style="flex: 1"
                                            type="text"
					    v-on:keyup.enter='onSearchRecipient'
                                        />
                                        <button
                                            class="com-btn"
                                            style="margin-left: 10px; height: 32px"
                                            @click="onSearchRecipient"
                                        >
                                            검색
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    파일 선택
                                    <span class="require">*</span>
                                </th>
                                <td style="padding: 10px; display: flex; height: auto">
                                    <input
                                        v-model="documentFile"
                                        class="design-input"
                                        readonly
                                        type="text"
                                        style="flex: 1"
                                    />
                                    <button class="com-btn" @click="onBrowse">찾아보기</button>
                                    <b-form-file
                                        id="file1"
                                        accept=".jpg, .jpeg, .png, .pdf"
                                        style="display: none"
                                        plain
                                        @change="handleFile"
                                    ></b-form-file>
                                </td>
                            </tr>
                            <tr>
                                <th>메모</th>
                                <td style="padding: 10px">
                                    <textarea v-model="memo" class="com-textarea" placeholder="메모입력"></textarea>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="bottom-btn" style="margin-top: 50px; padding-bottom: 0">
                        <button class="com-btn" @click="closeDocumentPop">취소</button>
                        <button class="com-btn blue" @click="onCompleteDocument" :disabled="!addDocumentEnable">
                            완료
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="searchCustomerPop" class="layer-pop square">
            <div class="view-content small-padding" style="width: auto">
                <button class="close" @click="searchCustomerPop = false">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="com-scroll-y">
                    <p class="pop-tit" style="font-size: 18px; margin-bottom: 15px">회원 검색</p>
                    <table class="com-table" style="margin-bottom: 40px">
                        <colgroup>
                            <col style="width: 60px" />
                            <col style="width: 240px" />
                            <col style="width: 200px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>번호</th>
                                <th>회원명</th>
                                <th>전화번호</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="(item, index) in customerList"
                                :key="index"
                                style="cursor: pointer"
                                @click="onSelectCustomer(index)"
                            >
                                <td>
                                    {{ index + 1 }}
                                </td>
                                <td>
                                    {{ item.namee }}
                                </td>
                                <td>
                                {{item.phone | phoneNumberFilter}}
                                </td>
                            </tr>
                            <tr v-if="customerList.length === 0">
                                <td colspan="100">등록된 내역이 없습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <document-preview-dlg
            v-if="documentPreviewPop"
            :show="documentPreviewPop"
            :fileUrl="selectedFileUrl"
            :close="handleCloseDocumentPreview"
        ></document-preview-dlg>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import BtnLoadingSpinner from '../../../components/BtnLoadingSpinner';
import moment from 'moment';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { pagingInfo } from '@/assets/js/common';
import XLSX from 'xlsx';
import { Utils } from '@/assets/js/utils';
import Axios from 'axios';
import DocumentPreviewDlg from '../../../components/DocumentPreviewDlg';

export default {
    name: 'SettingElectronicTemplateManage',
    mixins: [MixinAllowedMenu],
    components: {
        LoadingSpinner,
        BtnLoadingSpinner,
        DocumentPreviewDlg,
    },
    props: [],
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        centerStaffId() {
            const { getters } = this.$store;
            return getters['auth/staffId'];
        },
        centerChains() {
            // 체인 목록 [본점, 지점, 지점...] (체인점 최고권한자만 값이 있음)
            const { getters } = this.$store;
            return getters['auth/centerChains'];
        },
    },
    watch: {
        contractType(val) {
            this.recipient = null;
            this.recipientSearchStr = '';
            this.recipientSearchId = 0;

            this.checkComplete();
        },
    },
    created() {},
    mounted() {
        this.sender = parseInt(this.cId);

        this.init();
    },
    data() {
        return {
            centerId: 0,
            centerInfo: null,

            submenus: [
                { name: 'SettingElectronicContractManage', label: '계약 관리' },
                { name: 'SettingElectronicExternalDocument', label: '외부 문서' },
                { name: 'SettingElectronicTemplateManage', label: '템플릿 관리' },
                { name: 'SettingElectronicSignature', label: '서명' },
                { name: 'SettingElectronicSetting', label: '설정' },
            ],

            isLoading: false,

            contractSendList: [],
            contractSendListPagingInfo: { ...pagingInfo },
            contractSendListSortColumn: 'e_cre_dt',
            contractSendListSortType: 'DESC',
            totalItems: '',

            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],

            startDate: this.initStartDate(),
            endDate: this.initEndDate(),
            period: 'thisMonth', // 등록일 조회
            searchStr: '',
            searchDivision: 1,
            searchMethod: '',
            searchStatus: 0,

            selectedAll: false,
            selected: [],

            selectViewMore: [
                { type: 1, name: '업데이트' },
                { type: 2, name: '다운로드' },
                { type: 3, name: '발송취소' },
                { type: 4, name: '기한연장' },
            ],

            addDocument: false,
            addDocumentEnable: false,
            contractType: 'M',
            contractName: '',
            sender: '',
            recipient: null,
            documentFile: '',
            memo: '',
            uploadFiles: [], // base64, mimetype, name이 담김. 실제로 서버로 request할 data
            fileGroupId: 0,
            selectedDocumentIndex: -1,

            centerChainList: [], // 본점 + 지점 체인점 목록

            chainCenterType: [], // 체인 Center name 배열
            chainCenterTypeValue: [], // 체인 센터 Id 배열

            centerStaffList: [], // centerStaff 이름 목록
            centerStaffValueList: [], // centerStaff ID 목록
            recipientSearchStr: '',
            recipientSearchId: 0,

            searchCustomerPop: false,
            customerList: [],

            documentPreviewPop: false,
            selectedFileUrl: '',
        };
    },
    methods: {
        // 초기화
        async init() {
            this.isLoading = true;

            this.centerId = parseInt(this.cId); // 센터id
            this.centerChainList = this.centerChains; // 체인점 최고 관리자는 centerChains 에 본점 + 지점 목록이 있음
            await this.getCenterInfo(); // 로그인한 센터 정보 가져오기
            if (this.centerChainList != null) {
                if (this.centerChainList.length === 0) {
                    // 체인점 최고 관리자가 아닌 일반 센터 관리자 및 직원일 경우 접속한 아이디에 해당하는 센터만 센터 목록에 보임
                    this.chainCenterType.push(this.centerInfo.centerName);
                    this.chainCenterTypeValue.push(this.centerInfo.id);
                    this.centerId = this.centerInfo.id;
                } else if (this.centerChainList.length !== 0) {
                    // 체인점 최고 권한자일 경우 체인점에 속한 모든 센터가 목록에 보임
                    this.centerChainList.forEach((c) => {
                        this.chainCenterType.push(c.centerName);
                        this.chainCenterTypeValue.push(c.centerId);
                        this.centerId = this.centerInfo.id; // 접속한 centerId가 기본으로 선택 되게끔 함
                    });
                }
            }

            this.setSubMenu();
            this.fetchCenterStaffList(); // 매출직원, 담당강사 목록 가져오기

            this.onSearchList();

            this.isLoading = false;
        },

        setSubMenu() {
            this.submenus[0].valid = this.isAllowed('ME', 6) || this.isAllowed('ME', 7);
            this.submenus[1].valid = this.isAllowed('ME', 6) || this.isAllowed('ME', 7);
            this.submenus[2].valid = this.isAllowed('ME', 6);
            this.submenus[3].valid = this.isAllowed('ME', 6);
            this.submenus[4].valid = this.isAllowed('ME', 6);
        },

        // centerId 로 센터 정보 가져오기
        async getCenterInfo() {
            try {
                const { data } = await api.get(`/admin/api/center/${this.centerId}`);
                this.centerInfo = data;
            } catch (error) {
                console.log(error);
            }
        },

        // 매출직원, 담당강사 목록 가져오기
        async fetchCenterStaffList() {
            try {
                this.centerStaffList = [];
                this.centerStaffValueList = [];
                const { data } = await api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
                data.forEach((d) => {
                    this.centerStaffList.push(d.name);
                    this.centerStaffValueList.push(d.centerStaffId);
                });
            } catch (error) {
                alert('외부 문서 내역을 검색하는 동안 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 회원 목록 가져오기
        async fetchCustomerList() {
            try {
                // this.isLoading = true;
                const { data } = await this.sendGetCustomerList();
                this.customerList = data.items;

                // this.isLoading = false;
            } catch (error) {
                console.error('외부 문서 내역을 검색하는 동안 오류가 발생했습니다.');
                console.error(error);
            }
        },

        // 센터회원 Paging 목록 조회
        sendGetCustomerList() {
            const { centerId, recipientSearchStr } = this;
            const searchParams = {
                centerId,
                searchStr: recipientSearchStr,
                page: 1,
                limit: 9999,
            };
            return api.get(`/admin/api/center/${this.centerId}/customer`, {
                params: {
                    ...searchParams,
                },
            });
        },

        setSender(newValue) {
            this.sender = newValue;
        },

        setRecipient(newValue) {
            this.recipient = newValue;

            this.checkComplete();
        },

        setSearchDivision(newValue) {
            this.searchDivision = newValue;
          // if (newValue == 4) {
          //     this.searchStr = "";
          // }
        },
        // 검색 종료일
        initEndDate() {
            const endDate = moment().endOf('month').format('YYYY-MM-DD');
            return endDate;
        },

        // 검색 시작일
        initStartDate() {
            const startDate = moment().startOf('month').format('YYYY-MM-DD');
            return startDate;
        },

        periodc(newValue) {
            this.period = newValue;
            if (newValue === 'thisMonth') {
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'today') {
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'lastWeek') {
                this.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'threeMonth') {
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'sixMonth') {
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'year') {
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            }
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
        },

        setPageParams(data) {
            this.contractSendListPagingInfo.totalPages = data.meta.totalPages;
            this.contractSendListPagingInfo.page = data.meta.currentPage;
            this.contractSendListPagingInfo.totalItems = data.meta.totalItems;
            this.contractSendListPagingInfo.itemCount = data.meta.itemCount;
        },

        checkedAll() {
            // 전체 선택 기능
            this.selected = [];
            if (!this.selectedAll) {
                for (const i in this.contractSendList) {
                    this.selected.push(parseInt(i));
                }
            }
        },

        // 한 페지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.contractSendListPagingInfo.limit = val;
            this.onSearchList();
        },

        async onSearch() {
            this.contractSendListPagingInfo.page = 1;
            this.onSearchList();
        },

        async onSearchList() {
            try {
                this.isLoading = true;

                const { data } = await this.getDocumentList();
                this.setPageParams(data);
                this.contractSendList = data.items;
                this.totalItems = data.meta.totalItems;

            // if (this.searchDivision == 4) {
            //     this.searchStr = this.$options.filters.phoneNumberFilter(this.searchStr)
            // }

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },
        getDocumentList(isAll = false) {
            // 스웨거: Lesson Manage Paging 목록 조회
            let params = {
                startDate: moment(this.startDate).format('YYYYMMDD'),
                endDate: moment(this.endDate).format('YYYYMMDD'),
                searchDivision: this.searchDivision,
                // searchStr: this.searchStr.replace(new RegExp("-", 'g'), ""),
                searchStr: this.searchStr,
                searchMethod: this.searchMethod,
                contractSendListSortColumn: this.contractSendListSortColumn,
                contractSendListSortType: this.contractSendListSortType,
                ...this.contractSendListPagingInfo,
            };

            if (isAll) {
                params.page = 1;
                params.limit = 99999;
            }

            return api.get(`/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/external/document`, {
                params,
            });
        },

        onSearchDivision(type) {
            this.searchDivision = type;
        },

        onSearchMethod(type) {
            this.searchMethod = type;
        },

        // 이용권명 컬럼 클릭시
        onClickSendDt() {
            this.contractSendListSortColumn = 'e_cre_dt';
            if (this.contractSendListSortType === '' || this.contractSendListSortType === 'DESC') {
                this.contractSendListSortType = 'ASC';
            } else {
                this.contractSendListSortType = 'DESC';
            }

            this.onSearchList();
        },

        // 검색어 입력 처리
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }

            this.onSearch();
        },

        onConditionInit() {
            this.startDate = this.initStartDate();
            this.endDate = this.initEndDate();
            this.period = 'thisMonth';
            this.searchStr = '';
            this.searchDivision = 1;
            this.searchMethod = '';
            this.searchStatus = 0;

            // this.onSearchList();
        },

        // 페지 변경 Handler
        handlerPagenation(event, pagingType) {
            if (pagingType === 'contractSendList') {
                this.contractSendListPagingInfo.page = event;
                this.onSearchList();
            }
        },

        async deleteDocument() {
            if (this.selected.length == 0) {
                alert('계약서를 선택해 주세요.');
                return;
            }

            if (!confirm('삭제 하시겠습니까?')) return;

            const params = {
                selectedIds: this.contractSendList
                    .filter((item, index) => this.selected.indexOf(index) >= 0)
                    .map((i) => i.e_id)
                    .toString(),
            };

            await api.delete(`/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/external/document`, {
                params,
            });

            this.selected = [];

            this.onSearchList();
        },

        registerDocument() {
            this.initAddDocumentPop();
            this.addDocument = true;
        },

        handleCloseDocumentPreview() {
            this.documentPreviewPop = false;
        },

        async onShowDocument(i) {
            const externalDocument = this.contractSendList[i];
            const file = await api.get(`/admin/api/board/file-group/${externalDocument.e_file_group_id}`);
            if (file && file.data && file.data.length > 0) {
                this.selectedFileUrl = file.data[0].fileUrl;
                this.documentPreviewPop = true;

                // const link = document.createElement('a');
                // link.href = fileUrl;
                // link.target = "_blank"
                // document.body.appendChild(link);
                // link.click();
            }
            // return;
            // this.initAddDocumentPop();
            //
            // const externalDocument = this.contractSendList[i];
            //
            // this.selectedDocumentIndex = i;
            //
            // this.fileGroupId = externalDocument.e_file_group_id;
            // this.contractType = externalDocument.e_contract_member_type;
            // this.contractName = externalDocument.e_contract_name;
            // this.memo = externalDocument.e_memo;
            //
            // const file = await api.get(`/admin/api/board/file-group/${externalDocument.e_file_group_id}`);
            // if (file && file.data && file.data.length > 0) {
            //     const fileUrl = file.data[0].fileUrl;
            //     const paths = fileUrl.split("/");
            //     this.documentFile = paths[paths.length - 1];
            // }
            //
            // this.sender = externalDocument.e_sender_id;
            //
            // if (this.contractType == 'P') {
            //     this.recipient = externalDocument.e_recipient_id;
            // } else if (this.contractType = 'M') {
            //     this.recipientSearchStr = externalDocument.recipient_name;
            //     this.recipientSearchId = externalDocument.e_recipient_id;
            // }
            //
            // this.checkComplete();

            // this.addDocument = true
        },

        closeDocumentPop() {
            this.selectedDocumentIndex = -1;
            this.fileGroupId = 0;

            this.addDocument = false;
        },

        initAddDocumentPop() {
            this.selectedDocumentIndex = -1;

            this.addDocumentEnable = false;
            this.contractType = 'M';
            this.contractName = '';

            if (this.chainCenterType.length > 1) {
                this.sender = '';
            }

            this.recipient = null;
            this.documentFile = '';
            this.memo = '';
            this.uploadFiles = [];
            this.recipientSearchStr = '';
            this.recipientSearchId = 0;
        },

        async onCompleteDocument() {
            try {
                if (this.selectedDocumentIndex == -1) {
                    if (!confirm('문서를 등록하시겠습니까?')) {
                        return;
                    }
                } else {
                    if (
                        this.contractSendList[this.selectedDocumentIndex].e_contract_name == this.contractName &&
                        this.contractSendList[this.selectedDocumentIndex].e_sender_id == this.sender &&
                        this.contractSendList[this.selectedDocumentIndex].e_recipient_id ==
                            (this.contractType == 'P'
                                ? this.recipient
                                : this.contractType == 'M'
                                ? this.recipientSearchId
                                : 0) &&
                        this.contractSendList[this.selectedDocumentIndex].e_file_group_id == this.fileGroupId &&
                        this.contractSendList[this.selectedDocumentIndex].e_memo == this.memo
                    ) {
                        alert('변경된 정보가 없습니다.');
                        return;
                    }

                    if (!confirm('문서를 수정하시겠습니까?')) {
                        return;
                    }
                }
                const { data } = await api.post(
                    `/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/external/document`,
                    {
                        id:
                            this.selectedDocumentIndex == -1
                                ? 0
                                : this.contractSendList[this.selectedDocumentIndex].e_id,
                        name: this.contractName,
                        contractMemberType: this.contractType,
                        senderId: this.sender,
                        recipientId:
                            this.contractType == 'P'
                                ? this.recipient
                                : this.contractType == 'M'
                                ? this.recipientSearchId
                                : 0,
                        uploadFiles: this.uploadFiles,
                        fileGroupId: this.fileGroupId,
                        memo: this.memo,
                    }
                );

                this.onSearchList();

                if (data) {
                    if (this.selectedDocumentIndex == -1) {
                        alert('문서가 등록되었습니다.');
                    } else {
                        alert('문서가 수정되었습니다.');
                    }
                    this.closeDocumentPop();
                }
            } catch (error) {
                console.log(error);
            }
        },

        async onSearchRecipient() {
            await this.fetchCustomerList();

            this.searchCustomerPop = true;
        },

        onSelectCustomer(index) {
            this.recipientSearchStr = this.customerList[index].namee;
            this.recipientSearchId = this.customerList[index].center_cust_id;

            this.searchCustomerPop = false;

            this.checkComplete();
        },

        // File reader
        readFileAsync(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },

        async onBrowse() {
            document.querySelector('#file1').click();
        },

        // File 핸들러
        async handleFile(e) {
            try {
                console.log(e);
                const file = e.target.files[0];
                let base64data = await this.readFileAsync(file);
                this.base64data = base64data; // 이미지 미리보기
                base64data = base64data.split(',')[1];
                if (base64data === undefined) {
                    alert('빈 파일을 첨부할수 없습니다.');
                    return;
                }
                const fileInfo = {
                    filename: file.name,
                    mimetype: file.type,
                    base64data: base64data,
                };

                this.documentFile = fileInfo.filename;
                this.uploadFiles.push(fileInfo);
                this.fileGroupId = 0;

                this.checkComplete();
            } catch (error) {
                console.log(error);
                alert('파일 첨부중 오류가 발생하였습니다.');
            }
        },

        checkComplete() {
            if (
                this.contractName.length > 0 &&
                this.sender != '' &&
                ((this.contractType == 'P' && this.recipient != null) ||
                    (this.contractType == 'M' && this.recipientSearchId > 0) ||
                    this.contractType == 'E') &&
                this.documentFile.length > 0
            ) {
                this.addDocumentEnable = true;
            } else {
                this.addDocumentEnable = false;
            }
        },

        onKeyupContractName() {
            this.checkComplete();
        },
        download() {
            let link = document.createElement('a');
            link.download = 'anAnswer.png';
            link.href = document.getElementById('mycanvas').toDataURL();
            link.click();
        },

        // a 태그 파일 다운로드 Event
        async fileDownload(url) {
            Axios.get(url, { responseType: 'blob' })
                .then((response) => {
                    const index = url.lastIndexOf('.');
                    const extension = url.substring(index + 1);
                    const fileName = url.substring(url.lastIndexOf('/') + 1, url.length);

                    let type = 'application/pdf';
                    if (extension === 'png') {
                        type = 'application/png';
                    } else if (extension === 'jpg' || extension === 'jpeg') {
                        type = 'application/jpg';
                    }

                    const blob = new Blob([response.data], { type: type });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = fileName;
                    link.click();
                    URL.revokeObjectURL(link.href);
                    // const link = document.createElement('a');
                    // link.href = url;
                    // const paths = url.split("/");
                    // const filename = paths[paths.length - 1];
                    // link.setAttribute('download', filename);
                    // document.body.appendChild(link);
                    // link.click();
                })
                .catch(console.error);
        },
        async onDownloadDocument(fileGroupId) {
            const file = await api.get(`/admin/api/board/file-group/${fileGroupId}`);
            if (file && file.data && file.data.length > 0) {
                const fileUrl = file.data[0].fileUrl;
                this.fileDownload(fileUrl);
            }
        },

        // Excel Download
        async excelDownload() {
            const { data } = await this.getDocumentList(true);

            const excelDownloadArray = [];
            data.items.forEach((item) => {
                const temp = {};
                temp['등록일시'] = this.$options.filters.timestampFilter2(item.e_cre_dt);
                temp['구분'] = this.$options.filters.getContractMemberType(item.e_contract_member_type);
                temp['계약서명'] = item.e_contract_name;
                temp['발송인'] = item.cen_sender_name;
                temp['수신인'] = item.recipient_name;
                temp['수신전화번호'] = item.recipient_phone;
                temp['메모'] = item.e_memo;

                excelDownloadArray.push(temp);
            });
            const ws = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            const wscols = [{ wch: 30 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 60 }];
            ws['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            ws['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, '외부문서내역');
            XLSX.writeFile(wb, `외부문서내역_${new Date().toLocaleDateString().toString()}.xlsx`);
        },

        onKeydownSearchKey(event) {
            // if (this.searchDivision == 4) {
            //     if (event.key == "Backspace") return;
            //
            //     this.$refs.refSearchKey.value = this.$options.filters.phoneNumberFilter(this.searchStr)
            // }
        },
    },
};
</script>
<style lang="scss"></style>
